import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from '../../localization';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import { submitSignUp } from '../../store/actions/user.actions';
import { validation, currency, bank } from './validation.js';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { agentCode } from '../../config';
import jwtService from '../../services/jwtService';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { toastr } from 'react-redux-toastr';

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputUsername: '',
            inputOtp: '',
            inputEmail: '',
            inputPassword: '',
            inputPhoneNo: '',
            inputConfirmPassword: '',
            currencyName: 'EUR',
            bankAccountNo: '',
            bankAccountName: 'HANA BANK',
            agentCode: localStorage.getItem('agentCode') && localStorage.getItem('firstAgentCodeHit') ? localStorage.getItem('agentCode') : agentCode,
            code: '',
            checked: false,
            checkedError: false,
            usernameError: false,
            emailError: false,
            passwordError: false,
            confirmPasswordError: false,
            misMatchError: false,
            bankAccountNoError: false,
            agentCodeError: false,
            loading: false,
            phonenoError: false,
            confirmPwdType: 'password',
            pwdType: 'password',
            verified: true,
            otpModal: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupError !== this.props.signupError) {
            this.setState({ ...this.state, loading: false });
        }
        if (prevState.inputUsername !== this.state.inputUsername) {
            if (!this.state.inputUsername) {
                this.setState({ usernameError: true });
            } else if (this.state.inputUsername.length < validation.userName.min_length || this.state.inputUsername.length > validation.userName.max_length) {
                this.setState({ usernameError: true });
            } else {
                this.setState({ usernameError: false });
            }
        }

        if (prevState.inputPassword !== this.state.inputPassword) {
            if (!this.state.inputPassword) {
                this.setState({ passwordError: true });
            } else if (this.state.inputPassword.length < validation.passWord.min_length || this.state.inputPassword.length > validation.passWord.max_length) {
                this.setState({ passwordError: true });
            } else {
                this.setState({ passwordError: false });
            }
        }

        if (prevState.inputConfirmPassword !== this.state.inputConfirmPassword) {
            if (!this.state.inputConfirmPassword) {
                this.setState({ confirmPasswordError: true });
            } else {
                this.setState({ confirmPasswordError: false });
            }
        }
        if (prevState.inputConfirmPassword !== this.state.inputConfirmPassword) {
            if (this.state.inputPassword !== this.state.inputConfirmPassword) {
                this.setState({ misMatchError: true });
            } else {
                this.setState({ misMatchError: false });
            }
        }
        if (prevState.bankAccountNo !== this.state.bankAccountNo) {
            if (!this.state.bankAccountNo) {
                this.setState({ bankAccountNoError: true });
            } else {
                this.setState({ bankAccountNoError: false });
            }
        }
        if (prevState.agentCode !== this.state.agentCode) {
            if (!this.state.agentCode) {
                this.setState({ agentCodeError: true });
            } else {
                this.setState({ agentCodeError: false });
            }
        }
        if (prevState.checked !== this.state.checked) {
            if (!this.state.checked) {
                this.setState({ checkedError: true });
            } else {
                this.setState({ checkedError: false });
            }
        }
    }

    checkEmailFormat = (email) => {
        let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (email.match(mailFormat)) return true;
        else return false;
    };

    handleSubmit = () => {
        const {
            inputUsername,
            inputEmail,
            inputOtp,
            inputPassword,
            inputConfirmPassword,
            inputPhoneNo,
            bankAccountNo,
            agentCode,
            currencyName,
            bankAccountName,
            code,
            verified,
        } = this.state;
        const {
            usernameError,
            emailError,
            phonenoError,
            passwordError,
            confirmPasswordError,
            bankAccountNoError,
            agentCodeError,
            misMatchError,
            checkedError,
        } = this.state;
        let check = true;

        if (inputUsername.length < validation.userName.min_length || inputUsername.length > validation.userName.max_length) {
            check = false;
            this.setState({
                usernameError: true,
            });
        }

        if (inputEmail.length < validation.email.min_length || !this.checkEmailFormat(inputEmail)) {
            check = false;
            this.setState({
                emailError: true,
            });
        }

        if (inputPassword.length < validation.passWord.min_length || inputPassword.length > validation.passWord.max_length) {
            check = false;
            this.setState({
                passwordError: true,
            });
        }
        if (inputConfirmPassword.length < validation.passWord.min_length || inputConfirmPassword.length > validation.passWord.max_length) {
            check = false;
            this.setState({
                confirmPasswordError: true,
            });
        }
        if (inputPassword !== inputConfirmPassword) {
            check = false;
            this.setState({
                misMatchError: true,
            });
        }
        // if(bankAccountNo.length === 0) {
        //     check = false;
        //     this.setState({
        //         bankAccountNoError: true,
        //     })
        // }

        if (!this.state.checked) {
            check = false;
            this.setState({ checkedError: true });
        }
        if (check) {
            this.setState({ ...this.state, loading: true });
            const obj = {
                inputUsername,
                inputOtp,
                inputEmail,
                inputPhoneNo,
                inputPassword,
                inputConfirmPassword,
                currencyName,
                bankAccountNo,
                bankAccountName,
                code,
                agentCode,
            };
            if (!verified) {
                this.verifyEmail(inputEmail);
            } else {
                this.props.submitSignUp(obj, this.backToSignupForm);
            }
            localStorage.removeItem('firstAgentCodeHit');
        }
    };

    verifyEmail = (email) => {
        this.getOtp(email);
    };

    backToSignupForm = () => {
        this.setState({ otpModal: false, verified: true });
    };

    getOtp = async (email) => {
        let data = {
            email,
            type: 'signup',
        };
        try {
            let response = await jwtService.getOtp(data);
            toastr.success(response?.message);
            this.setState({ loading: false });
            this.setState({ otpModal: true });
            this.setState({ verified: true });
        } catch (error) {
            this.setState({ loading: false });
            this.setState({ otpModal: false });
            if (error.response.data.status === 400 && error.response.data.error === 'Email already exists') {
                toastr.error(error.response.data.error);
            } else {
                toastr.error('Something went wrong');
            }
        }
    };

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
            loading: false,
        });
    };

    handlePhone = (value, data) => {
        this.setState({ inputPhoneNo: value.slice(data.dialCode.length) });
        this.setState({ code: data.dialCode });
    };

    handleToggle = (e) => {
        if (this.state.checked) {
            this.setState({ checked: false });
        } else {
            this.setState({ checked: true });
        }
    };
    render() {
        let { userData } = this.props;
        let show = userData === null;
        const currencyList = currency.map((option) => (
            <option key={option} value={option}>
                {option}
            </option>
        ));
        const bankList = bank.map((option) => (
            <option key={option} value={option}>
                {option}
            </option>
        ));
        let {
            usernameError,
            emailError,
            pwdType,
            passwordError,
            confirmPwdType,
            confirmPasswordError,
            misMatchError,
            loading,
            phonenoError,
            currencyName,
            bankAccountNoError,
            bankAccountName,
            agentCodeError,
            checkedError,
            checked,
            otpModal,
        } = this.state;
        return (
            <Dialog
                onClose={this.props.hideSignUp}
                aria-labelledby="login-dialog-title"
                open={show}
                className="auth__modal login-modal desktop-signup"
                scroll="body"
            >
                <DialogTitle id="login-dialog-title" className="custom-modal-header" disableTypography>
                    <div className="dialog-logo-wrap d-flex justify-content-between">
                        {/* <img src="/images/sports/logo.png" alt="Logo" /> */}
                        {/* <span>{Translate.signingUpTakesMinutes}</span> */}
                        <span>{Translate.fastRegistration}</span>
                    </div>
                    <IconButton aria-label="close" className="close-modal" onClick={this.props.hideSignUp}>
                        <i className=" material-icons fs-22"> {Translate.close} </i>
                    </IconButton>
                </DialogTitle>
                <DialogContent className="pt-0 d-flex">
                    {/* <div className="signup-img-wrap">
                        <div className="signup-banner">
                            <div className="heading-container">
                                <p className="offer-text">Casino Welcome Offer</p>
                                    <p className="bonus-text">100% Bonus and 50 Free Spins</p>
                            </div>
                        </div>
                        <div className="rating-container">
                                <p className='rating-text'>jackpotCT has an average of <span>9.3 Rating</span> from the casino community.</p>
                            </div>
                    </div> */}
                    {otpModal ? (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSubmit();
                            }}
                            autoComplete="off"
                        >
                            <h2>Registration</h2>
                            <h4 style={{ margin: '10px 0px' }}>Signing up</h4>
                            <div className="mt-1">
                                <label>Submit Otp</label>
                                <input
                                    type="number"
                                    autoFocus
                                    className="auth__input"
                                    placeholder={Translate.enterOtp}
                                    id="inputOtp"
                                    minLength="6"
                                    maxLength="6"
                                    onChange={this.handleChange}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="signup-btn">
                                <Button
                                    variant="contained"
                                    className="btn d-flex justify-content-center btn-login my-2 signup-button"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? <LoadingIcon /> : Translate.signup}
                                </Button>
                            </div>
                        </form>
                    ) : (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSubmit();
                            }}
                        >
                            <div className={`mt-1 ${usernameError ? 'auth__error-field' : ''}`}>
                                <label>{Translate.username}</label>
                                <input
                                    type="text"
                                    autoFocus
                                    className="auth__input"
                                    placeholder={Translate.username}
                                    id="inputUsername"
                                    onChange={this.handleChange}
                                    autoComplete="username"
                                />
                                {usernameError && (
                                    <p className="auth__error sm">
                                        {Translate.name} {Translate.shouldBeSixtoFourteenCharacters}
                                    </p>
                                )}
                            </div>

                            <div className={`mt-2 ${emailError ? 'auth_error_field' : ''}`}>
                                <label>{Translate.email}</label>
                                <input
                                    type="email"
                                    className="auth__input"
                                    placeholder={Translate.email}
                                    id="inputEmail"
                                    onChange={this.handleChange}
                                    autoComplete="email"
                                />
                                {emailError && <p className="auth__error sm">{Translate.notValidEmail}</p>}
                            </div>

                            {/* <div className={`mt-2 ${phonenoError ? 'auth__error-field' : ''}`}>
                                <label>Phone</label>

                                <PhoneInput
                                    inputProps={{
                                        name: 'inputPhoneNo',
                                        required: true,
                                    }}
                                    country={'us'}
                                    inputStyle={{ color: '#000', backgroundColor: '#e1e3e5', width: '100%', borderStyle: 'none', height: '24px' }}
                                    buttonClass="button_class"
                                    containerClass="auth__input"
                                    enableSearch
                                    onChange={(value, code) => this.handlePhone(value, code)}
                                />
                            </div> */}
                            <div
                                style={{ flexDirection: 'column', alignItems: 'flex-start', position: 'relative' }}
                                className={`mt-2 d-flex position-relative ${passwordError ? 'auth__error-field' : ''}`}
                            >
                                <label>{Translate.password}</label>

                                <input
                                    type={pwdType}
                                    className="auth__input"
                                    placeholder={Translate.password}
                                    id="inputPassword"
                                    onChange={this.handleChange}
                                    autoComplete="current-password"
                                />
                                {pwdType == 'password' ? (
                                    <VisibilityIcon
                                        style={{ top: '40px' }}
                                        className="r-15 position-absolute cursor-pointer"
                                        onClick={() => this.setState({ pwdType: 'text' })}
                                    />
                                ) : (
                                    <VisibilityOffIcon
                                        style={{ top: '40px' }}
                                        className="r-15 position-absolute cursor-pointer"
                                        onClick={() => this.setState({ pwdType: 'password' })}
                                    />
                                )}
                            </div>
                            {passwordError && (
                                <p className="auth__error sm">
                                    {Translate.password} {Translate.shouldBeSixtoFourteenCharacters}
                                </p>
                            )}
                            <div
                                style={{ flexDirection: 'column', alignItems: 'flex-start', position: 'relative' }}
                                className={`mt-2 d-flex  position-relative ${confirmPasswordError ? 'auth__error-field' : ''}`}
                            >
                                <label>{Translate.passwordAgain}</label>
                                <input
                                    type={confirmPwdType}
                                    className="auth__input"
                                    placeholder={Translate.passwordAgain}
                                    id="inputConfirmPassword"
                                    onChange={this.handleChange}
                                    autoComplete="current-password"
                                />
                                {confirmPwdType == 'password' ? (
                                    <VisibilityIcon
                                        style={{ top: '40px' }}
                                        className="r-15 position-absolute cursor-pointer"
                                        onClick={() => this.setState({ confirmPwdType: 'text' })}
                                    />
                                ) : (
                                    <VisibilityOffIcon
                                        className="r-15 position-absolute cursor-pointer"
                                        onClick={() => this.setState({ confirmPwdType: 'password' })}
                                    />
                                )}
                            </div>
                            {confirmPasswordError ? (
                                <p className="auth__error sm">{Translate.required}</p>
                            ) : misMatchError ? (
                                <p className="auth__error sm">{Translate.passwordsDidNotMatch}</p>
                            ) : null}
                            {/* <div >
                             <select value = {currencyName} onChange={this.handleChange} id="currencyName" className="auth__input">
                               {currencyList}
                             </select>
                        </div>
                         <div className={`mt-0 ${bankAccountNoError ? 'auth__error-field' : ''}`}>
                            <input
                                type="text"
                                className="auth__input"
                                placeholder="Bank Account No"
                                id="bankAccountNo"
                                onChange={this.handleChange}
                               // onKeyPress={(e)=>isNaN(e.key)  ? e.preventDefault() : e.key}
                                autoComplete="bank-account-no"
                            />
                             {bankAccountNoError ? <p className="auth__error sm">This field is required</p> : null}
                        </div>
                        <div >
                             <select value = {bankAccountName} onChange={this.handleChange} id="bankAccountName" className="auth__input">
                               {bankList}
                             </select>
                       </div> */}
                            <div className={` d-flex my-2 ${checkedError ? 'auth__error-field' : ''}`}>
                                <div className="mr-2">
                                    <input type="checkbox" className="cursor-pointer" checked={checked} onChange={this.handleToggle} />{' '}
                                </div>
                                <label className={`${checkedError ? 'checkedError' : ''}`}>
                                    {' '}
                                    {Translate.readAll}{' '}
                                    <Link to={`/${Translate.getLanguage()}/d/support/terms-and-conditions`} className="terms_condition">
                                        {' '}
                                        {Translate.termsAndConditon}{' '}
                                    </Link>
                                </label>
                            </div>
                            <div className="signup-btn">
                                <Button
                                    variant="contained"
                                    className="btn d-flex justify-content-center btn-login my-2 signup-button"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? <LoadingIcon /> : Translate.signup}
                                </Button>
                            </div>
                        </form>
                    )}
                </DialogContent>
            </Dialog>
        );
    }
}

SignUp.propTypes = {
    userData: PropTypes.object,
    signupError: PropTypes.string,
    submitSignUp: PropTypes.func,
    hideSignUp: PropTypes.func,
    language: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        signupError: state.user.signupError,
        language: state.general.language,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitSignUp: (obj, callback) => dispatch(submitSignUp(obj, callback)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
